<div
  class="cursor-pointer symbol {{isCircle? 'symbol-circle' : ''}} hover-scale m-0 symbol-{{size}}px {{customClasses}}"
>
  <ng-container *ngIf="loaded">
    <img *ngIf="!!avatar" src="assets/media/avatars/300-2.jpg" alt="user" />

    <span
      *ngIf="!avatar"
      class="symbol-label bg-dark text-inverse-dark fw-bold"
    >
      {{ firstLetter }}
    </span>
  </ng-container>
  <ng-container *ngIf="!loaded">
    <span class="symbol-label bg-light text-inverse-dark fw-bold">
      <div class="spinner-border text-primary" role="status"></div>
    </span>
  </ng-container>
</div>
